import { render, staticRenderFns } from "./DepositRatesEditorModal.vue?vue&type=template&id=c6138fde"
import script from "./DepositRatesEditorModal.vue?vue&type=script&lang=js"
export * from "./DepositRatesEditorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports